export function checkCanOpenBirdviewActivity(item) {
  return Boolean(item.requestId)
}

export function getBirdviewActivityStatusKey(isDone) {
  return isDone ? 'TaskTable.StatusDoneKey' : 'TaskTable.StatusOpenKey'
}

export function getBirdviewActivityStatusTooltipKey(isDone) {
  return isDone
    ? 'TaskTable.ActionMarkAsOpenTooltipKey'
    : 'TaskTable.ActionMarkAsDoneTooltipKey'
}
